import { useEffect } from "react";

export function useModalKeyboardHandlers({ onClose, onSave, dependencies = [] }) {
    useEffect(() => {
        const handleKeyDown = (e) => {
            // Inside a dropdown, Esc closes its menu and Enter picks an option.
            if ((e.target.id || "").startsWith("react-select")) return;
            if (e.key === "Escape") {
                e.preventDefault();
                onClose();
            } else if (e.key === "Enter") {
                if (e.target.tagName !== "TEXTAREA") {
                    e.preventDefault();
                    onSave(e);
                    onClose();
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [onClose, onSave, ...dependencies]);
}
